import { NgModule } from '@angular/core';
import { OrderStatusPipe,CouponStatusPipe } from './order-status/order-status';


const pipeList = [
    OrderStatusPipe,
    CouponStatusPipe

]

@NgModule({
	declarations: [...pipeList,
    ],
	imports: [],
	exports: [...pipeList,
    ]
})
export class PipesModule {}
